<template>
  <div>
    <ViewAllListModal :user="user" :modalVisible="viewAllListModalShown" :modalType="modalType" v-on:modalHidden="onViewAllModalHidden" v-on:openCustomerModal="openUserInfoModal" v-on:openProModal="openUserInfoModal" v-on:openPingModal="openCreatePostModal" v-on:openShareModal="showShareModal" />
    <UserInfoModal :modalVisible="userModalShown" v-on:modalHidden="onUserInfoModalHidden" :user="targetUser" v-on:openPingModal="openCreatePostModal"/>
    <CreatePingModal :mentionableUsers="[...connections.pro.data, ...connections.customer.data]"
                     :modalVisible="pingModalShown" v-on:modalHidden="onPingModalHidden" :userId="user.id"
                     :prePopulatedMentionedUser="pingModalMentionedUser" :parentId="pingModalParentId"
                     :isStoreFront="false"
                     :is-organization-post="false"
                     :isPost="false"
                     :maxContentLength="1000"/>
      <ShareModal
          v-show="sharingMember"
          :modalVisible="shareModalShown"
          :mentionableUsers="[]"
          v-on:modalHidden="onShareModalHidden"
          :sharedUser="shareModalMentionedUser"
          :userId="user? user.id: null"
      />
    <div class="container mt-8 mx-auto">
      <div class="grid grid-cols-4 gap-x-12 content-wrapper">
        <div class="lg:block hidden">
          <UserDetail :user="user" />
          <NetworkReach :total="user.network_reach" />
          <ConnectedProsList :data="connections.pro.data" v-on:openAllConnectedProsModal="openViewAllModal" v-on:openPingModal="openCreatePostModal" v-on:openShareModal="showShareModal" :user="user"/>
          <MyCustomers :data="connections.customer.data" v-on:openAllCustomersModal="openViewAllModal" v-on:openCustomerModal="openUserInfoModal" v-on:openPingModal="openCreatePostModal" />
          <MyOrganizations :user="user" :show_status="dashboard" :organizations="organizations" :header="orgheader" :show_search_box="true"/>
      </div>
        <div class="lg:col-span-2 col-span-4">
          <CreatePost v-on:openCreatePost="openCreatePostModal" />
          <Current :user="user" :data="feedForCurrent" v-on:openPingModal="openCreatePostModal" :activeTags="activeTags" v-on:tagClicked="tagClicked"/>
        </div>
        <div class="lg:block hidden">
          <Ad :image="'/img/dashboardAd.png'" />
          <TagSearch :tags="user.featured_tags" v-on:tagClicked="tagClicked"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import CreatePost from './partials/CreatePost.vue'
import UserDetail from './partials/UserDetail.vue'
import Ad from '../Utils/Ad.vue'
import NetworkReach from './partials/NetworkReach.vue'
import ConnectedProsList from './partials/ConnectedProsList.vue'
import MyCustomers from './partials/MyCustomers.vue'
import Current from './partials/Current.vue'
import TagSearch from './partials/TagSearch.vue'
import CreatePingModal from '../Ping/CreatePingModal.vue'
import ShareModal from '../Organizations/partials/ShareModal.vue'
import UserInfoModal from './partials/UserInfoModal.vue'
import ViewAllListModal from './partials/ViewAllListModal.vue'
import MyOrganizations from './partials/MyOrganizations.vue'
export default {
    data() {
        return {
            pingModalShown: false,
            shareModalShown: false,
            userModalShown: false,
            viewAllListModalShown: false,
            modalType: '',
            targetUser: {},
            pingModalMentionedUser: {},
            shareModalMentionedUser: false,
            sharingMember: false,
            pingModalParentId: null,
            feedForCurrent: null,
            activeTags: [],
            orgheader: 'My Organizations',
            dashboard: "dashboard",
        }
    },
    props: ['user', 'feed', 'connections', 'organizations'],
    mounted() {
    },
    methods: {
        openCreatePostModal(user, parentId) {
          if(user) {
            this.pingModalMentionedUser  = user;
          } else {
            this.pingModalMentionedUser = null;
          }
          if(parentId) {
            this.pingModalParentId  = parentId;
            this.pingModalMentionedUser = null;
          } else {
            this.pingModalParentId = null;
          }
          this.pingModalShown = true;
        },
        openUserInfoModal(user) {
          // TODO: remove this when no longer using fake input
          if(user.icon) {
            this.targetUser  = {...user.pro, icon: user.icon}
          } else {
            this.targetUser = {...user};
          }
          this.userModalShown = true;
        },
        openViewAllModal(modalType, items){
          this.modalType = modalType;
          this.viewAllListModalShown = true;
        },
        showShareModal( member){
            this.shareModalMentionedUser = member;
            this.sharingMember = true;
            this.isModalForPost = false;
            this.shareModalShown = true;
        },
        onModalHidden(reloadFeed) {
          this.pingModalShown = false;
          this.userModalShown = false;
          this.shareModalShown = false;
          this.viewAllListModalShown = false;
          if(reloadFeed){
            this.reloadFeed();
          }
        },
        onViewAllModalHidden(reloadFeed) {
            this.viewAllListModalShown = false;
        },
        onUserInfoModalHidden(reloadFeed) {
            this.userModalShown = false;
        },
        onPingModalHidden(reloadFeed) {
            this.pingModalShown = false;
        },
        onShareModalHidden(reloadFeed) {
            this.shareModalShown = false;
        },
        reloadFeed(){
          axios.get(this.feed.path)
          .then(response => {
            this.feedForCurrent = response.data;
          })
          .catch(error =>{
            console.log(error);
          })
        },
        tagClicked(tag){
          if(!this.activeTags.includes(tag)){
            this.activeTags.push(tag);
          }else{
            this.activeTags.splice(this.activeTags.indexOf(tag), 1);
          }
        }
    },
    components: {
        UserDetail,
        CreatePost,
        Ad,
        NetworkReach,
        ConnectedProsList,
        MyCustomers,
        MyOrganizations,
        Current,
        TagSearch,
        CreatePingModal,
        ShareModal,
        UserInfoModal,
        ViewAllListModal,
    },
    created() {
      this.feedForCurrent = this.feed;
    },
}
</script>
